import { render, staticRenderFns } from "./ValidationDetails.vue?vue&type=template&id=93ed526c&"
import script from "./ValidationDetails.vue?vue&type=script&lang=ts&"
export * from "./ValidationDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports